import { useIntl } from 'react-intl';
import { CounterList } from '../CounterList';
import CreateUser from '../../../../assets/create_eula_user_group.webp';

export const OnboardEuDataActUserExplained = () => {
    const intl = useIntl();

    const title = intl.formatMessage({ id: 'intl-msg:infoDialog.functions.onboardThirdPartyForEUDataAct.headline' });

    return (
        <div className={'row'} data-testid={'Create Eula User Group'}>
            <div className={'col-xs-12'}>
                <h4>{title}</h4>
                <div className={'margin-bottom-25'}>
                    <img src={CreateUser} alt={'tdv'} className={'max-width-75pct'} />
                </div>
                <CounterList
                    chapter={'onboardThirdPartyForEUDataAct'}
                    hardcodedStrings={{ euDataActUser: 'EU Data Act User' }}
                    count={4}
                />
            </div>
        </div>
    );
};
